type SocketHandler = (data: any) => void;

let socket: WebSocket | null = null;
let reconnectTimer: ReturnType<typeof setTimeout> | null = null;
let reconnectAttempt = 0;
const handlers = new Set<SocketHandler>();

const getWsUrl = (): string | null => {
  const explicit = (process.env.REACT_APP_WS_URL || "").trim();
  if (explicit) return explicit;

  const apiHost = process.env.REACT_APP_API_HOST || "";
  if (apiHost.includes("qa-tz.cl") || apiHost.includes("www.qa-tz.cl")) {
    return "wss://www.qa-tz.cl/ws/services/";
  }
  return null;
};

const notifyHandlers = (data: any) => {
  handlers.forEach((handler) => {
    try {
      handler(data);
    } catch (err) {
      console.error("Error en handler WebSocket:", err);
    }
  });
};

const scheduleReconnect = () => {
  if (handlers.size === 0) return;
  if (reconnectTimer) return;

  const delay = Math.min(1000 * 2 ** reconnectAttempt, 15000);
  reconnectAttempt += 1;
  reconnectTimer = setTimeout(() => {
    reconnectTimer = null;
    ensureSocketConnected();
  }, delay);
};

const ensureSocketConnected = () => {
  if (socket && (socket.readyState === WebSocket.OPEN || socket.readyState === WebSocket.CONNECTING)) {
    return;
  }

  const wsUrl = getWsUrl();
  if (!wsUrl) {
    return;
  }

  console.log("🌐 Intentando conectar WebSocket a:", wsUrl);

  try {
    socket = new WebSocket(wsUrl);
  } catch (err) {
    console.error("❌ Error creando instancia WebSocket:", err);
    scheduleReconnect();
    return;
  }

  socket.onopen = (event) => {
    console.log("✅ WebSocket conectado:", event);
    reconnectAttempt = 0;
  };

  socket.onclose = () => {
    console.warn("⚠️ WebSocket cerrado");
    socket = null;
    scheduleReconnect();
  };

  socket.onerror = (error) => {
    console.error("❌ Error WebSocket:", error);
  };

  socket.onmessage = (event) => {
    try {
      const data = JSON.parse(event.data);
      notifyHandlers(data);
    } catch (e) {
      console.error("⚠️ Error parseando mensaje:", e, "Contenido bruto:", event.data);
    }
  };
};

/**
 * Suscribe un handler a mensajes WS. Conecta el socket si aún no hay conexión.
 * Devuelve función para desuscribirse.
 */
export const subscribeSocket = (handler: SocketHandler): (() => void) => {
  handlers.add(handler);
  ensureSocketConnected();
  return () => {
    handlers.delete(handler);
  };
};

/** @deprecated Preferir subscribeSocket; se mantiene por compatibilidad. */
export const connectSocket = (
  onMessage: SocketHandler,
  _onOpen?: () => void,
  _onClose?: () => void
) => {
  return subscribeSocket(onMessage);
};

export const sendSocketMessage = (data: any) => {
  if (socket && socket.readyState === WebSocket.OPEN) {
    socket.send(JSON.stringify(data));
  } else {
    console.warn("🚫 Socket no conectado, mensaje no enviado:", data);
  }
};
